import React, { useContext, useMemo } from "react";
import { EuiIcon, EuiTabbedContent } from "@elastic/eui";
import { EntityProfileContext } from ".";

import ProfileEntity from "./ProfileEntity";
import ProfileStats from "./ProfileStats";
import ProfileTabName from "./ProfileTabName";

import { ProfileEntitiesWrapper } from "./style";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const statsTab = {
    name: (
        <ProfileTabName
            label="Statistics"
            icon={
                <EuiIcon
                    size="s"
                    type="stats"
                />
            }
        />
    ),
    id: "stats",
    content: <ProfileStats />,
};

const generateTabs = (fields, showStats) => [
    ...fields.map((field) => ({
        name: (
            <ProfileTabName
                entityName={field.entityName}
                label={field.label}
            />
        ),
        id: field.name,
        content: <ProfileEntity field={field} />,
    })),
    ...(showStats ? [statsTab] : []),
];

function ProfileEntities() {
    const { relationFields, statsFields } = useContext(EntityProfileContext);
    const history = useHistory();
    const entityName = history.location?.state?.entityName;

    const tabs = useMemo(
        () => generateTabs(relationFields, !!statsFields),
        [relationFields, statsFields]
    );
    const statsIndex = useMemo(() => tabs.findIndex((tab) => tab.id === "stats"), [tabs]);


    return (
        <ProfileEntitiesWrapper paddingSize="none">
            <EuiTabbedContent
                tabs={tabs}
                expand={false}
                initialSelectedTab={
                    entityName
                        ? tabs.filter((tab) => tab.id === entityName)[0]
                        : tabs[statsIndex > -1 ? statsIndex : 0]
                }
                autoFocus="selected"
            />
        </ProfileEntitiesWrapper>
    );
}

export default ProfileEntities;
